export default __webpack_public_path__ + "static/media/techforyou.5de7def4.jpg";